export default __webpack_public_path__ + "static/media/hht1_ep7_minisitcom_04.e5016b40.png";